import * as React from "react";
import { type IconProps, iconProps } from "../util/IconProps";
export function CheckmarkCircleIcon(props: IconProps): React.JSX.Element {
  const { color, size, ...rest } = iconProps(props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm5.514 8.145a1 1 0 1 0-1.528-1.29l-5.605 6.637-2.398-2.582a1 1 0 0 0-1.466 1.361l3.167 3.41a1 1 0 0 0 1.497-.036l6.333-7.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
